import React, { useCallback } from "react";
import styled from "styled-components";
import { Close, ZoomIn, StarBorder, Star } from "@material-ui/icons";
import {
  setCompanyFavouriteGRSDB,
  deleteCompanyFavouritesGRSDB,
  deleteCompanyFavourites,
  setCompanyFavourite,
} from "utils/api";
import { useNavigate, useLocation } from "react-router-dom";
import CompanyDetailedInfo from "./CompanyDetailedInfo";

const Holder = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;
const H3 = styled.h3`
  margin: 0;
  word-break: break-word;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  line-height: 1.3;
`;
const Description = styled.p`
  margin: 8px 0 0 0;
`;
const StyledInfo = styled.div`
  position: absolute;
  cursor: pointer;
  bottom: ${({ events }) => (events ? 40 + events * 67 : 40)}px;
  left: -136px;
  width: 250px;
  background-color: #fff;
  box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.3);
  padding: 10px;
  font-size: 14px;
  z-index: 100;
  display: flex;
  align-items: center;

  &::after {
    position: absolute;
    content: "";
    width: 0px;
    height: 0px;
    bottom: -30px;
    left: 45%;
    border: 18px solid transparent;
    border-top: 17px solid ${({ color }) => (color ? color : "#fff")};
  }
`;
const ZoomInStyled = styled(ZoomIn)`
  color: ${({ theme }) => theme.primaryColor};
`;
const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: -30px;
  font-size: 20px;
  padding: 0px;
  width: 22px;
  height: 22px;
  border-radius: 100px;
  box-shadow: 0px 0px 0px transparent;
  border: 0px solid transparent;
  text-shadow: 0px 0px 0px transparent;
  background: transparent;
  cursor: pointer;
  color: #fff;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: #353535;
  }
`;
const FavoriteButton = styled.div`
  display: flex;
  align-items: center;
  z-index: 9999;
`;

export default function Info({
  events,
  markerColor,
  markerPosition,
  infoDialogData,
  id,
  selectedCompany,
  setShowInfoDialog,
  isLoading,
  openInfo,
  setOpenInfo,
  channels,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const { name, description } = infoDialogData;
  const isOpen = openInfo === id;
  const showStar = selectedCompany?.co_street && selectedCompany?.co_zip && selectedCompany?.co_city;

  const handleCompanyFavorite = useCallback(
    e => {
      e.preventDefault();
      const isDak = selectedCompany.isDak;
      if (!showStar) {
	return;
      }
      if (isDak) {
        if (selectedCompany.favorite) {
          deleteCompanyFavourites(selectedCompany.id);
        } else {
          setCompanyFavourite(selectedCompany.id);
        }
        selectedCompany.favorite = !selectedCompany.favorite;
        return;
      }

      if (selectedCompany.favorite) {
        deleteCompanyFavouritesGRSDB(selectedCompany.bisnode_id);
      } else {
        setCompanyFavouriteGRSDB(selectedCompany);
      }
      selectedCompany.favorite = !selectedCompany.favorite;
    },
    [selectedCompany]
  );

  return (
    <>
      <StyledInfo>
        <CloseButton
          onClick={e => {
            e.stopPropagation();
            setShowInfoDialog(-1);
          }}
        >
          <Close fontSize="inherit" />
        </CloseButton>
        <Holder>
          <div style={{ width: " 100%" }}>
            {events &&
              events.length > 0 &&
              events.map((ev, index) => (
                <Holder key={index}>
                  <div
                    onClick={() =>
                      !isLoading && selectedCompany
                        ? setOpenInfo(id)
                        : navigate({
                            pathname: `/map/event/${ev.id}`,
                            search: location.search,
                          })
                    }
                    style={{ flex: "1 1 100%" }}
                  >
                    <H3>{ev.name}</H3>
                    <Description>{ev.description}</Description>
                    <hr />
                  </div>
                  {!selectedCompany ? (
                    <ZoomInStyled
                      onClick={() => {
                        !isLoading && selectedCompany
                          ? setOpenInfo(id)
                          : navigate({
                              pathname: `/map/event/${id}`,
                              search: location.search,
                            });
                      }}
                    />
                  ) : (
                    <FavoriteButton onClick={handleCompanyFavorite}>
			  {showStar ? (selectedCompany.favorite ? <Star /> : <StarBorder />) : null} 
                    </FavoriteButton>
                  )}
                </Holder>
              ))}
            <Holder>
              <div
                onClick={() => {
                  !isLoading && selectedCompany
                    ? setOpenInfo(id)
                    : navigate({
                        pathname: `/map/event/${id}`,
                        search: location.search,
                      });
                }}
                style={{ flex: "1 1 100%" }}
              >
                <H3>{name}</H3>
                {description && <Description>{description}</Description>}
              </div>
              {!selectedCompany ? (
                <ZoomInStyled
                  onClick={() => {
                    !isLoading && selectedCompany
                      ? setOpenInfo(id)
                      : navigate({
                          pathname: `/map/event/${id}`,
                          search: location.search,
                        });
                  }}
                />
              ) : (
                <FavoriteButton onClick={handleCompanyFavorite}>
		   {showStar ? (selectedCompany.favorite ? <Star /> : <StarBorder />) : null} 
                </FavoriteButton>
              )}
            </Holder>
          </div>
        </Holder>
      </StyledInfo>
      {isOpen && (
        <CompanyDetailedInfo
          markerPosition={markerPosition}
          markerColor={markerColor}
          id={id}
          selectedCompany={selectedCompany}
          isOpen={isOpen}
          setIsOpen={setOpenInfo}
          title={name}
          channels={channels}
        />
      )}
    </>
  );
}
